module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"integration-completed-title":"Integration completed!","integration-completed-description":"The integration was completed with success.","developed":"Developed by"},"pt-BR":{"integration-completed-title":"Integração concluída!","integration-completed-description":"A integração foi concluída com sucesso.","developed":"Desenvolvido por"}}')
  delete Component.options._Ctor
}
